/** The command format this build writes. Bumped only alongside a journal migration. */
export const COMMAND_SCHEMA_VERSION = 1;
export const CLEARABLE_EDGE_FIELDS = [
    'color',
    'width',
    'dash',
    'label',
    'controlPoints',
];
//# sourceMappingURL=types.js.map